<template>
    <div class="py-4 container-fluid">      
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">
                        <div class="col-lg-3">
                            <overview-mating-side-nav />
                        </div>
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <mating-overview />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>        
</template>
<script>
import OverviewMatingSideNav from "./components/OverviewMatingSideNav.vue"
import MatingOverview from "./components/MatingOverview.vue"

export default {
    name: 'Mating_details_page',
    components: {
        OverviewMatingSideNav,
        MatingOverview
    },
    data() {
        return {
            Id: '',
            mating: [],
            gets: []
        }
    },
    async mounted() {
    },
}
</script>